// third-party
import { FormattedMessage } from 'react-intl';

// assets
import {
  IconDashboard,
  IconBuildingStore,
  IconBell,
  IconTicket,
  IconAccessPoint,
  IconPhoto,
  IconCalendar,
  IconReceipt2,
  IconHistory,
  IconCash,
  IconUser,
  IconNews,
  IconUserOff
} from '@tabler/icons';

const icons = {
  IconDashboard,
  IconBuildingStore,
  IconBell,
  IconTicket,
  IconAccessPoint,
  IconPhoto,
  IconCalendar,
  IconReceipt2,
  IconHistory,
  IconCash,
  IconUser,
  IconUserOff,
  IconNews
};

// ==============================|| MENU ITEMS - DASHBOARD ||============================== //

const dashboard = {
  id: 'Menu',
  title: <FormattedMessage id="Menu" />,
  icon: icons.IconDashboard,
  type: 'group',
  children: [
    // {
    //     id: 'dashboard',
    //     title: <FormattedMessage id="dashboard" />,
    //     type: 'item',
    //     url: '/dashboard',
    //     icon: icons.IconDashboard,
    //     breadcrumbs: false
    // },
    // {
    //     id: 'couponlist',
    //     title: <FormattedMessage id="couponlist" />,
    //     type: 'item',
    //     url: '/couponlist',
    //     icon: icons.IconTicket,
    //     breadcrumbs: false
    // },
    // {
    //     id: 'notificationlist',
    //     title: <FormattedMessage id="notificationlist" />,
    //     type: 'item',
    //     url: '/notificationlist',
    //     icon: icons.IconBell,
    //     breadcrumbs: false
    // },
    // {
    //     id: 'shop',
    //     title: <FormattedMessage id="shop" />,
    //     type: 'item',
    //     url: '/shop',
    //     icon: icons.IconBuildingStore,
    //     breadcrumbs: false
    // },
    // {
    //     id: 'beacon',
    //     title: <FormattedMessage id="beacon" />,
    //     type: 'item',
    //     url: '/beacon',
    //     icon: icons.IconAccessPoint,
    //     breadcrumbs: false
    // },
    // {
    //     id: 'event-schedule',
    //     title: <FormattedMessage id="event-schedule" />,
    //     type: 'item',
    //     url: '/eventschedule',
    //     icon: icons.IconCalendar,
    //     breadcrumbs: false
    // },
    // {
    //     id: 'media-manager',
    //     title: <FormattedMessage id="media-manager" />,
    //     type: 'item',
    //     url: '/mediamanager',
    //     icon: icons.IconPhoto,
    //     breadcrumbs: false
    // },
    {
      id: 'mypage',
      title: <FormattedMessage id="mypage" />,
      type: 'item',
      url: '/mypage',
      icon: icons.IconUser,
      breadcrumbs: false
    },
    {
      id: 'favorite',
      title: <FormattedMessage id="favorite" />,
      type: 'item',
      url: '/favorite',
      icon: icons.IconNews,
      breadcrumbs: false
    },
    {
      id: 'subscription',
      title: <FormattedMessage id="subscription" />,
      type: 'item',
      url: '/subscription',
      icon: icons.IconReceipt2,
      breadcrumbs: false
    },
    {
      id: 'subscription-history',
      title: <FormattedMessage id="subscription-history" />,
      type: 'item',
      url: '/subscriptionhistory',
      icon: icons.IconHistory,
      breadcrumbs: false
    },
    {
      id: 'delete-account',
      title: <FormattedMessage id="delete-account" />,
      type: 'item',
      url: '/deleteaccount',
      icon: icons.IconUserOff,
      breadcrumbs: false
    }

    // {
    //   id: 'method-of-payment',
    //   title: <FormattedMessage id="method-of-payment" />,
    //   type: 'item',
    //   url: '/methodofpayment',
    //   icon: icons.IconCash,
    //   breadcrumbs: false
    // }
    // {
    //   id: 'account',
    //   title: <FormattedMessage id="account" />,
    //   type: 'item',
    //   url: '/account',
    //   icon: icons.IconUser,
    //   breadcrumbs: false
    // }
    // {
    //     id: 'analytics',
    //     title: <FormattedMessage id="analytics" />,
    //     type: 'item',
    //     url: '/dashboard/analytics',
    //     icon: icons.IconDeviceAnalytics,
    //     breadcrumbs: false
    // }
  ]
};

export default dashboard;
